<template>
  <!-- 環境設定画面 -->
  <div id="PDashboardSystemSettingModal">
    <div class="modal-card" style="width:900px;">
      <header class="modal-card-head">
        <p class="modal-card-title">環境設定</p>
      </header>
      <section class="modal-card-body" style="height: 680px;">
        <b-tabs>
          <b-tab-item label="表示項目"><DisplayItemSetting ref="displayItemSetting"/></b-tab-item>
          <b-tab-item label="表示テンプレート"><DisplayTemplateSetting ref="displayTemplateSetting"/></b-tab-item>
          <b-tab-item label="転記テンプレート"><TranscriptionTemplateSetting ref="textTemplateSetting"/></b-tab-item>
        </b-tabs>
      </section>
      <footer class="modal-card-foot">
        <b-button class="is-primary" :disabled="roleId == role.role_salesOffice || isErrorOccerred" style="margin-left: auto;" @click="updateSystemSetting()">OK</b-button>
        <b-button class="is-primary" @click="cancel()">キャンセル</b-button>
      </footer>
    </div>
  </div>
</template>

<script>
const UNEXPECTED_ERROR = "予期しないエラーが発生しました。";
import { role } from "@/components/mock/base/const.js";
import DisplayItemSetting from "@/components/mock/guest/patientdashboard/DisplayItemSetting";
import TranscriptionTemplateSetting from "@/components/mock/guest/patientdashboard/TranscriptionTemplateSetting";
import DisplayTemplateSetting from "@/components/mock/guest/patientdashboard/DisplayTemplateSetting";
export default {
  name: "PDashboardSystemSettingModal",
  props: {
    displayTemplate: null
  },
  components: {
    DisplayItemSetting: DisplayItemSetting,
    TranscriptionTemplateSetting: TranscriptionTemplateSetting,
    DisplayTemplateSetting: DisplayTemplateSetting,
  },
  data() {
    let userInfo = this.getUserInfo();
    return {
      displayItemList: [],                     // 初期表示項目リスト
      textTemplateList: [],                    // 初期テキストテンプレートリスト
      displayTemplateDeleteList: [],           // 表示テンプレート削除リスト
      textTemplateDisplayList: [],             // テキストテンプレート表示リスト
      textTemplateDeleteList: [],              // テキストテンプレート削除リスト
      isErrorOccerred: false,                  // エラー発生時キャンセル以外を非活性
      role: role,                              // ユーザーロール
      roleId: userInfo.roleId,                 // 操作ユーザが担当営業の場合はレポートを出力できないように制限
      displayTemplateListOriginal: [],         // 表示テンプレートリスト（オリジナル）
      textTemplateListOriginal: [],            // 転記テンプレートリスト（オリジナル）
    };
  },
  async mounted() {
    // 環境設定初期情報取得
    const _this = this;
    await this.apiCall(
      function (client) {
        return client.apis.externalPDashboard.getSystemSettingPOST({
          body: {}
        });
      },
      function (result) {
        if (result.status == 200) {
          _this.displayItemList = result.obj.displayItemList;
          _this.textTemplateList = result.obj.textTemplateList;
          // 【表示項目】タブ側に受け渡し
          _this.$refs.displayItemSetting.setDisplayItemInfo(_this.getCopy(_this.displayItemList), _this.getCopy(_this.displayTemplate));
          // 【表示テンプレート】初期表示時のオリジナルリスト（更新時の比較に使用）
          _this.displayTemplateListOriginal = _this.getCopy(result.obj.displayTemplateList);
          // 【表示テンプレート】タブ側に受け渡し
          _this.$refs.displayTemplateSetting.setDisplayTemplateInfo(result.obj.displayTemplateList, _this.displayTemplate);
          // 【転記テンプレート】初期表示時のオリジナルリスト（更新時の比較に使用）
          _this.textTemplateListOriginal = _this.getCopy(result.obj.textTemplateInfo.textTemplateList);
          // 【転記テンプレート】タブ側に受け渡し
          _this.$refs.textTemplateSetting.setTextTemplateInfo(result.obj.textTemplateInfo);
        } else {
          _this.isErrorOccerred = true;
          // エラーメッセージ表示
          _this.showErrorMessage(UNEXPECTED_ERROR);
        }
      },
      function (error) {
        _this.isErrorOccerred = true;
        // エラーメッセージ表示
        _this.showErrorMessage(error);
      }
    );
  },
  methods: {
    // OKボタン押下処理
    async updateSystemSetting() {
      const _this = this;
      this.$dialog.confirm({
        title: "　",
        message: "変更されたデータを更新します。<br/>よろしいでしょうか？",
        confirmText: "OK",
        cancelText: "キャンセル",
        onConfirm: async() => {
          // 【表示項目】表示テンプレートの設定情報更新
          // 表示項目タブで設定した項目の表示/非表示、表示順で設定情報を更新
          _this.$refs.displayItemSetting.updateSettingList();
          // 【表示テンプレート】編集済リストを取得
          let displayTemplateEditedList = _this.getDisplayTemplateEditedList();
          // 【転記テンプレート】編集済リストを取得
          let textTemplateEditedList = _this.getTextTemplateEditedList();

          await this.apiCall(
            function (client) {
              return client.apis.externalPDashboard.updateSystemSettingPOST({
                body: {
                  // 【表示テンプレート】更新リスト
                  displayTemplateList: displayTemplateEditedList,
                  // 【表示テンプレート】削除リスト
                  displayTemplateDeleteList: _this.$refs.displayTemplateSetting.displayTemplateDeleteList,
                  // 【転記テンプレート】登録・更新リスト
                  textTemplateDisplayList: textTemplateEditedList,
                  // 【転記テンプレート】削除リスト
                  textTemplateDeleteList: _this.$refs.textTemplateSetting.textTemplateDeleteList
                },
              });
            },
            function (result) {
              if (result.status == 200) {
                let settingList = _this.$refs.displayItemSetting.displayTemplateSettingList;
                let displayTemplateList = result.body.displayTemplateList;
                let textTemplateList = result.body.textTemplateList;
                _this.$emit("backSystemSetting", settingList, displayTemplateList, textTemplateList);
                _this.showMessage("登録が完了しました。", _this.$parent.close);
              }
            },
            function (error) {
              _this.isErrorOccerred = true;
              // エラーメッセージ表示
              _this.showErrorMessage(error);
            }
          );
        },
      });
    },
    // 表示テンプレートの編集済リスト取得
    getDisplayTemplateEditedList() {
      // 表示テンプレートの編集済リスト
      let displayTemplateEditedList = [];

      // 表示テンプレートタブから最新の表示テンプレートリストを取得
      let displayTemplateList = this.$refs.displayTemplateSetting.displayTemplateList;

      // 初期表示時にコピーをとっておいたリストと項目ごとに比較
      for (let displayTemplate of displayTemplateList) {
        let displayTemplateOriginal = this.displayTemplateListOriginal.find(item => displayTemplate.id == item.id);
        if (displayTemplateOriginal) {
          if (displayTemplate.defaultFlag != displayTemplateOriginal.defaultFlag ||
              displayTemplate.displayOrder != displayTemplateOriginal.displayOrder ||
              displayTemplate.templateName != displayTemplateOriginal.templateName) {
            // 編集されている項目があったら編集済リストに追加
            displayTemplateEditedList.push(displayTemplate);
          }
        }
      }

      return displayTemplateEditedList;
    },
    // 転記テンプレートの編集済リスト取得
    getTextTemplateEditedList() {
      // 転記テンプレートの編集済リスト
      let textTemplateEditedList = [];

      // 転記テンプレートタブから最新の転記テンプレートリストを取得
      let textTemplateList = this.$refs.textTemplateSetting.textTemplateList;

      for (let textTemplate of textTemplateList) {
        // IDが未設定の場合は新規登録なので編集済リストに追加
        if (!textTemplate.id) {
          textTemplateEditedList.push(textTemplate);
        // IDが設定されていた場合、初期表示時にコピーをとっておいたリストと項目ごとに比較
        } else {
          let textTemplateListOriginal = this.textTemplateListOriginal.find(item => textTemplate.id == item.id);
          if (textTemplateListOriginal) {
            if (textTemplate.defaultFlag != textTemplateListOriginal.defaultFlag ||
                textTemplate.displayOrder != textTemplateListOriginal.displayOrder ||
                textTemplate.templateName != textTemplateListOriginal.templateName ||
                textTemplate.text != textTemplateListOriginal.text) {
              // 編集されている項目があったら編集済リストに追加
              textTemplateEditedList.push(textTemplate);
            }
          }
        }
      }

      return textTemplateEditedList;
    },
    // キャンセルボタン押下処理
    cancel() {
      // 【表示項目】編集済みかを判定
      let isEditedDisplayItemSetting = this.isEditedDisplayItemSetting();

      // 【表示テンプレート】編集済リストを取得
      let displayTemplateEditedList = this.getDisplayTemplateEditedList();
      // 【表示テンプレート】削除リストを取得
      let displayTemplateDeleteList = this.$refs.displayTemplateSetting.displayTemplateDeleteList;

      // 【転記テンプレート】編集済リストを取得
      let textTemplateEditedList = this.getTextTemplateEditedList();
      // 【転記テンプレート】削除リストを取得
      let textTemplateDeleteList = this.$refs.textTemplateSetting.textTemplateDeleteList;

      // 編集済みリストと削除リストの合計件数
      let editedCount = displayTemplateEditedList.length + displayTemplateDeleteList.length
                      + textTemplateEditedList.length + textTemplateDeleteList.length;

      if (!isEditedDisplayItemSetting && editedCount == 0) {
        // 変更がない場合はそのまま閉じる
        this.$parent.close();
      } else {
        this.$dialog.confirm({
          title: "　",
          message: "変更されたデータは更新されません。<br/>よろしいでしょうか？",
          confirmText:"OK",
          cancelText: "キャンセル",
          onConfirm: async() => {
            this.$parent.close();
          }
        });
      }
    },
    // 表示項目タブが編集済みかを判定
    isEditedDisplayItemSetting() {
      // 表示項目タブで設定した項目の表示/非表示、表示順で設定情報を更新
      this.$refs.displayItemSetting.updateSettingList();

      // 更新前の設定情報
      let originalSettingList = this.displayTemplate.settingList;
      // 更新後の設定情報
      let updatedSettingList = this.$refs.displayItemSetting.displayTemplateSettingList;

      // 編集済みかを判定(初期表示時に自動で追加または削除された設定情報は判定の対象外とする)
      for (let originalSetting of originalSettingList) {
        // 同じ項目IDの設定情報を更新後の設定情報から抽出
        let updateSetting = updatedSettingList.find(setting => setting.itemId == originalSetting.itemId);
        // 表示順に変更がある場合(表示フラグが変更になれば表示順も変更されるため表示フラグの判定は不要)
        if (updateSetting && updateSetting.itemDisplayOrder != originalSetting.itemDisplayOrder) {
          // 編集済み
          return true;
        }
      }

      // 編集なし
      return false;
    }
  },
};
</script>

<style lang="scss" scoped>
.modal-card-body {
  padding: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/patientdashboard/PDashboardSystemSettingModal.vue